import { TransportType } from "@syla/shared/types/helpers/TransportType";
import { withoutNullable } from "@syla/shared/types/helpers/withoutNullable";
import {
  GetGroupsRequestQuery,
  TransactionSortOption,
} from "@syla/shared/types/requests/GetGroupsRequest";

import { GetGroupsResponse } from "@syla/shared/types/responses/GetGroupsResponse";
import axios from "axios";
import { OrderFilterSetting } from "../../types/order/orderQuery";
import { filterToFilterParams } from "./filterToFilterParams";
import { parseOrderResponseItem } from "./parseOrderResponseItem";

export interface GetGroupsProps {
  accountId: string;
  pageParam: number;
  limit: number;
  sort: TransactionSortOption | undefined;
  filter: OrderFilterSetting;
}

export async function getGroups({
  accountId,
  pageParam = 0,
  limit = 8,
  sort,
  filter,
}: GetGroupsProps): Promise<GetGroupsResponse> {
  const params: GetGroupsRequestQuery = {
    limit,
    start: pageParam * limit,
    sort,
    ...filterToFilterParams(filter),
  };
  const response = await axios.get<TransportType<GetGroupsResponse>>(
    `/accounts/${accountId}/orders`,
    {
      params,
    },
  );

  return deserialise(response.data);
}

function deserialise(
  data: TransportType<GetGroupsResponse>,
): GetGroupsResponse {
  return {
    ...data,
    data: withoutNullable(
      data.data.map((data) => parseOrderResponseItem(data)),
    ),
  };
}
